var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"weather_page",staticClass:"page page-weather"},[_c('h2',{staticClass:"page-header"},[_vm._v("Weather Forecast")]),_c('Weather',{key:'weather_for_'+_vm.woeid,attrs:{"detailed":"","woeid":_vm.woeid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }